<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/TaxMasterTableview" v-if="PopupType == 0"></BacktoPage>

          <Headerlayout :headertext="taxId
            ? $t('Tax.TaxMaster.EditFormHeader')
            : $t('Tax.TaxMaster.FormHeader')
            " :contenttext="$t('Tax.TaxMaster.FormHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="form-white-bg my-3">
        <b-form @submit.prevent="IsSubmit">
          <b-row>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <TextField :required-icon="true" :name="$t('5004.code')" :id="$t('5004.code')" :label="$t('5004.code')"
                  :rules="{ required: true }" :disabled="true" v-model="taxform.Code" placeholder=" "
                  :autofocus="true" />
              </div>
            </b-col>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <CustomDropdown :required-icon="true" :label="$t('5004.taxtype')" v-model="taxform.TaxTypeId"
                  :rules="{ required: true }" :disabled="false" :name="$t('5004.taxtype')" :id="$t('5004.taxtype')"
                  :items="TaxTypeOptions" @update:value="" :showClear="false" :autofocus="true" />
              </div>
            </b-col>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <CustomDropdown :required-icon="true" :label="$t('5004.categorytype')" v-model="taxform.TaxType"
                  :rules="{ required: true }" :disabled="TaxTypeDisable" :name="$t('5004.categorytype')"
                  :id="$t('5004.categorytype')" :items="categorytypeoptions" @update:value="" :showClear="false"
                  :autofocus="true" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <CustomDropdown :required-icon="true" :label="$t('5004.ratetype')" v-model="taxform.RateType"
                  :rules="{ required: true }" :disabled="false" :name="$t('5004.ratetype')" :id="$t('5004.ratetype')"
                  :items="ratetypeoptions" @update:value="" :showClear="false" :autofocus="true" />
              </div>
            </b-col>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <TextField :required-icon="true"
                  :name="taxform.RateType == 1 ? $t('5004.percentage') : $t('5004.amount')"
                  :id="taxform.RateType == 1 ? $t('5004.percentage') : $t('5004.amount')"
                  :label="taxform.RateType == 1 ? $t('5004.percentage') : $t('5004.amount')"
                  :rules="{ required: true, decimal: true }" v-model="taxform.RatePercentage" :autofocus="true"
                  placeholder="" @keyup="RatePercentageKeyup" />
              </div>
            </b-col>
            <b-col :lg="PopupType == 0 ? '3' : '6'" :md="PopupType == 0 ? '3' : '6'" sm="6" cols="12">
              <div class="field">
                <TextField :required-icon="true" name="Tax name" id="Tax name" :label="$t('5004.name')"
                  :rules="{ required: true }" v-model="taxform.TaxName" :autofocus="true" placeholder="" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <div class="d-flex flex-row-reverse mt-5">
              <Footer @cancel="$router.back(), IsClear()" :label="btnlable" :cancelhide="true" CancelLabel="Back"
                :loading="Saveloading" />
            </div>
          </b-row>
        </b-form>
      </b-row>
    </b-container>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, watch } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../components/GeneralButtons/SaveButton.vue";
import TaxService from "../../../../../../modules/Inventory/Service/TaxService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
// import MastersService from "../../../../modules/Inventory/Service/MastersService";
// import { checkPermission } from "../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    TaxType: {
      type: Number,
      default: 1,
    },
    PopupType: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Loader,
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    Footer,
    BacktoPage,
    Headerlayout,
    TextField,
    Cancel,
    Save,
    CustomDropdown,
  },

  setup(props, { emit }) {
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const toast = useToast();
    const routers = useRouter();
    const router = useRoute();
    const taxId = router.query.Id;
    const OperationId: any = Number(router.query.OperationId);
    let Saveloading = ref(false);
    let btnlable = ref();
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let TaxTypeDisable = ref(false);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    onMounted(async () => {

      document.addEventListener("keydown", onKeyUp);

      if (taxId != "" && taxId != null) {
        btnlable.value = "Update";
        await IsEdit();
      } else {
        btnlable.value = "Save";
        await GetCode();
        taxform.value.TaxType = props.TaxType;

      }

      await LoadTaxTypes();


      if (
        (props.TaxType == 1 && props.PopupType == 1) ||
        (props.TaxType == 2 && props.PopupType == 2)
      ) {
        TaxTypeDisable.value = true;
      } else {
        TaxTypeDisable.value = false;
      }

    });

    watch(
      () => t("btn.save"),
      (newValue) => {
        btnlable.value = newValue;
      }
    );

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      if (props.PopupType == 0) {
        //routers.back();
        setupHistoryManagement(routers, 2);
      } else {
        emit("close");
      }
    }

    let categorytypeoptions = [
      {
        value: 1,
        name: "Purchase Tax",
      },
      {
        value: 2,
        name: "Sales Tax",
      },
    ];

    let ratetypeoptions = [
      {
        value: 1,
        name: "Percentage",
      },
      {
        value: 2,
        name: "Amount",
      },
    ];


    let TaxTypeOptions = ref([]);

    const taxform = ref({
      CreatedByName: "",
      TaxPercentage: 0,
      Formula: "",
      TaxEncExc: true,
      Taxes: "",
      TaxPrintname: "",
      TaxSubType: 0,
      FormCTax: 0,
      IsDependent: true,
      TotalTaxPer: 0,
      GSTNO: "",

      Id: 0,
      Code: "",
      TaxTypeId: ref(),
      TaxName: "",
      RatePercentage: "0",
      RateType: ref(1),
      TaxType: ref(),

      EffectiveDate: "",
      ExpiryDate: "",

      HospitalId: HospitalId,
      BranchId: BranchId,

      CreatedAt: "",
      ModifiedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });

    const IsEdit = async () => {
      try {
        debugger;
        const response = await TaxService.getfindonedata(taxId, HospitalId);
        let data = response["result"];
        Object.keys(taxform.value).forEach((key) => {
          if (data[key]) taxform.value[key] = data[key];
        });

        // taxform.value.TaxType = data.TaxType;
        // taxform.value.RateType = data.RateType;

      } catch (error) {
        alert(error);
      }
    };

    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
        Iscommon: 1,
        RoleId: rolesData.RoleId || 0,

      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      taxform.value.Code = result;
      if (result) {
      }
    }

    const IsSubmit = async () => {
      debugger;
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        debugger;

        if (parseFloat(taxform.value.RatePercentage) <= 0 && taxform.value.RateType == 1) {
          toast.add({
            severity: "warn",
            summary: "Invalid Percentage",
            detail: "The entered percentage rate cannot exceed 100%. Please enter a value between 0 and 100.",
            life: 3000,
          });

          taxform.value.RatePercentage = "0";
          Saveloading.value = false;
          return false;
        }

        if (parseFloat(taxform.value.RatePercentage) <= 0 && taxform.value.RateType == 2) {
          toast.add({
            severity: "warn",
            summary: "Invalid Amount",
            detail: "The entered amount must be greater than 0. Please provide a valid amount.",
            life: 3000,
          });

          taxform.value.RatePercentage = "0";
          Saveloading.value = false;
          return false;
        }

        taxform.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        taxform.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        taxform.value.BranchId = 0;
        taxform.value.HospitalId = HospitalId;
        taxform.value.ModifiedBy = UserId;
        taxform.value.CreatedBy = UserId;
        taxform.value.EntityId = Number(Entitydata.value.EntityId);
        taxform.value.EntityOperationId = OperationId;

        taxform.value.EffectiveDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        taxform.value.ExpiryDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        if (taxform.value.Id != 0) {
          const response = await TaxService.updatedata(taxform.value);
          let message = response["ErrorInfo"].ErrorCode;

          if (response["result"] == "Already" && message == null) {
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;

            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          const response = await TaxService.createdata(taxform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            Saveloading.value = false;

            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;

            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;

        alert(error);
      }
    };

    async function LoadTaxTypes() {
      debugger;
      try {
        const response = await TaxService.GetTaxTypes(HospitalId);

        TaxTypeOptions.value = response["result"]
          .map((item) => {
            item.name = item.TaxTypeName;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    const copydataModel = JSON.parse(JSON.stringify(taxform.value));
    const copyselectOption = JSON.parse(JSON.stringify(TaxTypeOptions.value));

    const IsClear = () => {
      Object.assign(taxform.value, copydataModel);
      Object.assign(TaxTypeOptions.value, copyselectOption);
      emit("update:selectedItem", undefined);
      emit("close");
    };

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      taxform.value.TaxName = "";
    }

    function RatePercentageKeyup() {
      debugger;
      if (taxform.value.RateType == 1) {
        let value = parseFloat(taxform.value.RatePercentage);
        if (value > 100) {
          toast.add({
            severity: "warn",
            summary: "Invalid Percentage",
            detail: "Percentage cannot be greater than 100.",
            life: 3000,
          });

          taxform.value.RatePercentage = "0";

          return false;
        }
      }
    }

    return {
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsClear,
      Saveloading,
      taxform,
      categorytypeoptions,
      ratetypeoptions,
      IsSubmit,
      IsEdit,
      alreadyclosetrigger,
      alreadyexistpop,
      btnlable,
      TaxTypeDisable,
      taxId,
      TaxTypeOptions,
      RatePercentageKeyup
    };
  },

});
</script>
